import { type MultiselectAccountValue } from "~/features/userAdministration/manageUsers/components/DropdownWithMultiselect/DropdownWithMultiSelect";

export const selectedOrderQuoteAccountDropdown = (list: MultiselectAccountValue[]) =>
  list
    .filter((account) => account.isChecked)
    .map((item) => item.value)
    .join(",");
